import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare let gtag: Function;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {

    constructor(private router: Router) {
    }


    pageTitleTag(eventName: any) {
        // this.router.events
        //     .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
        //     .subscribe(event => {

                // const pagePath = event.urlAfterRedirects.toLowerCase();
                console.log(event);

                // 🔥 Track ONLY registration page
                // if (pagePath.includes('registration')) {

                gtag('event', 'page_view', {
                    // page_path: pagePath,
                    page_title: `registration - ${eventName}`,
                    page_name: `registration - ${eventName}`,
                    page_location: window.location.href,
                    debug_mode: true
                });

                console.log('GA page_view sent:', eventName);
                // }
            // });

    }

    trackEvent(eventName: string, params?: object) {
        gtag('event', eventName, params);
        console.log(params);

    }
}
